// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import paperclipIcon from "@/assets/icons/paperclip.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type PaperclipIconProps = Omit<IconProps, "name">;

export function PaperclipIcon(props: PaperclipIconProps): React.ReactNode {
  return <Icon name={paperclipIcon} {...props} />;
}
